import { Drawer } from "antd";
import React from "react";
import styles from "css/mobile/mypage.module.css";
import { useTranslation } from "react-i18next";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-13
 * 작성자 : 김희민
 * 설명 : 모바일 일정카드 우측 하단 회의실 정보 클릭시 상세팝업
 */
export default function DetailEndpointPop({
  isOpenEndpointDetail,
  closeEndpointDetail,
  endpoints,
}) {
  const { t } = useTranslation();
  return (
    <Drawer
      className={styles.endpoint_drawer}
      open={isOpenEndpointDetail}
      onClose={closeEndpointDetail}
      placement="bottom"
      maskClosable={true}
      height="auto"
      title={null}
      styles={{ header: { display: "none" } }}
    >
      <div className={styles.endpointContainer}>
        <div className={styles.endpointHeader}>
          <h2 className={styles.endpointTitle}>{t("LABEL.TITLE.ROOM_INFO")}</h2>
          <img
            src={
              process.env.REACT_APP_CLIENT_URL + "img/mobile/mypage/close.png"
            }
            alt="close"
            className={styles.endpointClose}
            onClick={closeEndpointDetail}
          />
        </div>
        <div className={styles.endpointContent}>
          {endpoints?.length === 0 && (
            <div className={styles.ep}>{t("LABEL.NO_MEETING_ROOM")}</div>
          )}
          {endpoints?.length > 0 &&
            endpoints.map((endpoint, index) => (
              <div className={styles.ep} key={index}>
                <div className={styles.epName}>{endpoint.ENDPOINT_NM}</div>
              </div>
            ))}
        </div>
      </div>
    </Drawer>
  );
}
